let categoryBlocks3 = document.querySelectorAll(
  ".shop-by-category3 .category-block"
);
console.log("sbc3",categoryBlocks3);
let categoryHeads3 = document.querySelectorAll(
  ".shop-by-category3 .category-head"
);
  console.log("sbc3",categoryHeads3);

categoryHeads3.forEach((el, ind) => {
  el.addEventListener("click", () => {
    let headButton = el;
    let targetId = el.dataset.block;
    categoryHeads3.forEach((el, ind) => {
      headButton == el
        ? el.classList.add("active")
        : el.classList.remove("active");
    });
    categoryBlocks3.forEach((el, ind) => {
      if (el.dataset.id == targetId) {
        el.classList.add("active");
        console.log("class added");
        el.style.opacity = "0";
        setTimeout(() => {
          el.style.opacity = "1";
        });
      } else {
        el.classList.remove("active");
      }
    });
  });
});
